import * as React from "react";
import { useRecoilValue } from "recoil";

import BasePopup from "../../../popups/BasePopup.jsx"
import { loacLayerAtom } from './atoms'
import { supergroups, groups } from './metadata'

const LoacGroupPopup = ({ data }) => {
	const loacLayer = useRecoilValue(loacLayerAtom)
  const props = data.properties

    const renderText = () => {
        let g = null

        if (loacLayer.value === 'supergroup') {
            g = supergroups.find((sg) => sg.id === props.supergroup)
        } else {
            g = groups.find((g) => g.id === props.group)
        }

        return renderGroup(g)
    }

  const renderGroup = (group) => {
  	return (
  		<>
  			<h2 style={{
  				lineHeight: "1.5rem",
  			}}>
  				{group.id}: {group.name}
  			</h2>
      	<p>{group.description}</p>
  		</>
  	)
  }

  return (
    <BasePopup
      coords={data.coords}
      offset={1}
      anchor="bottom"
      maxWidth="480px"
      style={{
        color: "black",
        fontSize: "13px",
        width: "auto",
        height: "480px",
        overflowY: "hidden",
      }}>

      <div style={{
        paddingLeft: "1rem",
        paddingRight: "1rem",
        width: "100%",
        maxHeight: "calc(480px - 2rem)", // Account for popup box margins
        overflowY: "auto",
      }}>
      	{renderText()}
      </div>
    </BasePopup>
  )
}

export default LoacGroupPopup;